export var ALLOWED_SELF_SERVE_COUNTRY = {
    'United States': 'US',
    Canada: 'CA',
};
export var DD_TERMS_AND_CONDITIONS_URL = 'https://help.doordash.com/work/s/terms-and-conditions-us';
export var DD_PRIVACY_POLICY_URL = 'https://help.doordash.com/consumers/s/privacy-policy-us';
